import React from 'react'
import {Col, Row, Tooltip, Label} from 'reactstrap'
import 'react-datetime/css/react-datetime.css'
import apiBarcode from '../../services/api/apiBarcode'
import moment from 'moment'
import {
    listTags,
    listPrint,
    listGenerate,
    listLabel,
    listLocal,
    listOverTime,
    listStatus,
    shippingPlan,
    optionNote,
    REQUEST_UPDATE_ORDER,
    optionOrderType,
    shippingLevels,
    optionsError2D,
    listWarningShip,
    listPartner,
    optionsHoldShip,
    optionsCombineShip,
    optionsRequestPhotoStatus,
} from '../helpers/filtersTable.json'
import changeDateFormat from "../helpers/changeDateFormat"
import CustomMultiSelect from "../../components/CustomMultilSelect/CustomMultiSelect"
import FilterSelect from "./FilterLists/FilterSelect"
import FilterInput from "./FilterLists/FilterInput"
import FilterDateTime from "./FilterLists/FilterDateTime"
import FilterCheckBox from "./FilterLists/FilterCheckBox"
import MultiSelect from "./FilterLists/MutilSelect"
import {element} from "prop-types";
import { Select } from 'antd'
import { getListShippingCarrierApp } from '../../services/api/apiFFM'
import { canViewStoreName } from '../../services/StorageServices'

const EMPTY_TAGS = []

const INIT_FILTERS = {
    hide_archived: 'hide_archived',
    production_status: ['pending', 'in_production', 'labelled'],
    product_types_mode: 'in',
    search : '',
    shipping_carrier: [],
    status : [],
    order_ids : '',
    order_names: '',
    product_types: '',
    tags: [],
}

class ListItemsFilter extends React.Component {
    state = {
        filters: {
            color: [],
            size: [],
            type: [],
            brand_name: []
        },
        filter: this.props.filter,
        product_types_mode: false,
        type_overtime: '',
        error: {
            from: false,
            to: false,
        },
        show_image: true,
        mode: '',
        delayDays: {},
        tooltipReset: false,
        listShippingCarrier: [],
        allShippingCarrier: [],
        SearchStoreValue: '',
        ListTags : [],
        BrandNames : [],
        Types : []
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.filter !== prevProps.filter) {
            this.setState({
                filter: this.props.filter,
                ListTags: this.props.filter.list_tags,
                Types: this.props.filter['products.type'] || [],
            })
        }
    }

    componentDidMount() {
        this._fetchFilters()
        this._fetchFiltersBrandName()
        this._fetchFiltersShippingCarrier()

        const {filter} = this.props
        if (filter['products.overtimeLte'] >= 1 || filter['products.overtimeGt']) {
            this.setState({
                type_overtime: 'time',
            })
        } else if (filter['products.remaining_time[from]'] >= 0 || filter['products.remaining_time[to]']) {
            this.setState({
                type_overtime: 'remaining_time',
            })
        } else {
            this.setState({
                type_overtime: filter['products.overtime'],
            })
        }
    }

    _fetchFilters = async () => {
        try {
            const resRead = await apiBarcode.getFilters()
            const {success, data, message} = resRead.data

            if (!success) {
                throw new Error(message)
            }

            this.setState(prevState => ({filters: {...prevState.filters, ...data}}))
        } catch (e) {
            alert(e.message)
        }
    }

    _fetchFiltersBrandName = async () => {
        try {
            const payload = {
                limit: 500,
                page: 1
            }

            const resRead = await apiBarcode.getListBrands(payload)

            const {success, data, message} = resRead.data
            const brands = data.Brands
            const brandNameArrs = brands.map(brand => {
                return brand.name
            })

            if (!success) {
                throw new Error(message)
            }

            this.setState(prevState => ({filters: {...prevState.filters, brand_name: brandNameArrs}}))

        } catch (e) {
            alert(e.message)
        }
    }

    _fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length>0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
              }) : []
            this.setState({
                listShippingCarrier: shippingCarriers.filter(i=>!!i.is_active)|| [],
                allShippingCarrier: shippingCarriers || []
            })
            
        } catch (error) {
            alert(error.message)
        }
    } 

    _handleChangeSelect = (name, value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [name]: value,
            },
        }, () => {
            const {filter} = this.state
            const {onChangeFilter} = this.props

            if (value === 'All') {
                delete filter[name]
            }

            delete filter['beforeId']
            delete filter['afterId']

            if (name === 'shipping_level') {
                if (`${value}` !== '60') {
                    delete filter[name]
                } else {
                    filter[name] = +value
                }
            }

            // "Loại trừ Waiting update design" nằm trong dropdown Request update (name="tags")
            // nhưng thực chất phải gửi qua field exclude_tags riêng (giống link từ Home/Report),
            // không gộp chung vào mảng tags.
            if (name === 'tags' && Array.isArray(filter.tags)) {
                if (filter.tags.includes('exclude-waiting-update-design')) {
                    filter.exclude_tags = 'waiting-update-design'
                    filter.tags = filter.tags.filter(tag => tag !== 'exclude-waiting-update-design')
                    if (!filter.tags.length) delete filter.tags
                } else {
                    delete filter.exclude_tags
                }
            }

            if (typeof onChangeFilter === 'function') {
                onChangeFilter(filter)
            }
        })
    }

    // Ghép thêm option "exclude-waiting-update-design" vào danh sách selected của dropdown Request update
    // khi filter.exclude_tags đang bật, để checkbox hiển thị đúng trạng thái — nhưng giữ nguyên reference
    // của filter.tags khi không cần ghép, tránh tạo mảng mới mỗi lần render làm popup bị reset khi đang mở.
    _getRequestUpdateSelected = () => {
        const { filter } = this.state
        const tags = filter.tags || EMPTY_TAGS

        if (filter.exclude_tags !== 'waiting-update-design') return tags

        if (this._cachedExcludeSelectedSource === tags) {
            return this._cachedExcludeSelected
        }

        this._cachedExcludeSelectedSource = tags
        this._cachedExcludeSelected = [...tags, 'exclude-waiting-update-design']

        return this._cachedExcludeSelected
    }

    _handleChangeBarcodeNumber = (name, value) => {
        const {filter: _filter} = this.state
        const {barcodeNumber} = _filter

        this.setState({
            filter: {
                ..._filter,
                barcodeNumber: {
                    ...barcodeNumber,
                    [name]: value,
                },
            },
        }, () => {
            const {filter} = this.state

            if (value === '') delete filter.barcodeNumber[name]

            this.props.onChangeFilter(filter)
        })
    }

    _handleChangeInput = (name, value) => {
        const {filter: _filter} = this.state

        this.setState({
            filter: {
                ..._filter,
                [name]: value,
            },
            SearchStoreValue: '',
        }, () => {
            const {filter} = this.state

            if (value === '' || value === '\n') delete filter[name]
            this.props.onChangeFilter(filter, 1500)
        })
    }

    _handleChangeOverTime = (name, value) => {
        const newFilter = Object.assign({}, this.state.filter)
        newFilter[name] = value

        if (value === 'All') {
            delete newFilter[name]
        }

        if (value === 'time') {
            delete newFilter['products.overtime']
            delete newFilter['products.remaining_time']
            delete newFilter['products.remaining_time[from]']
            delete newFilter['products.remaining_time[to]']
            delete newFilter['products.delayedGenLabel']

            this.setState({
                filter: {
                    ...newFilter,
                },
            })
        } else if (value === 'remaining_time') {
            delete newFilter['products.overtime']
            delete newFilter['products.remaining_time']
            delete newFilter['products.overtimeGt']
            delete newFilter['products.overtimeLte']
            delete newFilter['products.delayedGenLabel']

            this.setState({
                filter: {...newFilter},
            })
        } else if (value === 'products.delayedGenLabel') {
            delete newFilter['products.overtime']
            delete newFilter['products.remaining_time']
            delete newFilter['products.remaining_time[from]']
            delete newFilter['products.remaining_time[to]']
            delete newFilter['products.overtimeGt']
            delete newFilter['products.overtimeLte']
            delete newFilter['products.overtime']

            newFilter[value] = 'y'

            this.props.onChangeFilter(newFilter)
        } else {
            delete newFilter['products.remaining_time[from]']
            delete newFilter['products.remaining_time[to]']
            delete newFilter['products.overtimeGt']
            delete newFilter['products.overtimeLte']
            delete newFilter['products.delayedGenLabel']

            this.props.onChangeFilter(newFilter)
        }

        if (name === 'products.overtime') {
            this.setState({
                type_overtime: value,
            })
        }
    }

    _handleChangeDelay = (name, value) => {
        const {filter: _filter} = this.state

        this.setState({
            mode: value,
        })

        if (value !== 'days') {
            delete _filter['generate_label_config.delay_days']
            delete _filter['generate_label_config']

            this.setState({
                delayDays: {},
                filter: {
                    ..._filter,
                    [name]: value,
                },
            }, () => {
                const {filter} = this.state

                if (value === 'All') {
                    delete filter['generate_label_config']
                    delete filter[name]
                }

                delete filter['beforeId']
                delete filter['afterId']

                this.props.onChangeFilter(filter)
            })
        }

        if (value === 'default') {
            delete _filter['generate_label_config.delay_days']
            delete _filter['generate_label_config.mode']

            this.setState({
                delayDays: {},
                filter: {
                    ..._filter,
                    generate_label_config: value,
                },
            }, () => {
                const {filter} = this.state

                if (value === 'All') {
                    delete filter[name]
                    delete filter['generate_label_config']
                }

                delete filter['beforeId']
                delete filter['afterId']

                this.props.onChangeFilter(filter)
            })
        }
    }

    _handleChangeInputDelay = (name, value) => {
        this.setState({
            delayDays: {
                from: parseInt(value),
                to: parseInt(value),
            },
        }, () => {
            const {delayDays, filter} = this.state

            delete filter['generate_label_config.mode']
            delete filter['generate_label_config']
            delete filter['beforeId']
            delete filter['afterId']

            const newFilter = Object.assign(filter, {'generate_label_config.delay_days': {...delayDays}})

            if (isNaN(parseInt(value)) || parseInt(value) === 0) {
                delete filter['generate_label_config.delay_days']
            }

            this.props.onChangeFilter(newFilter)
        })
    }

    _handleChangeInputOvertime = (name, value) => {
        const {filter: _filter} = this.state

        if (parseFloat(value) < 0) {
            return this.setState({
                error: {
                    [name]: value < 0,
                },
            })
        } else {
            this.setState({
                error: {
                    from: false,
                    to: false,
                },
            })
        }

        this.setState({
            filter: {
                ..._filter,
                [name]: parseFloat(value),
            },
        }, () => {
            const {filter} = this.state

            if (value === "" || value == null) {
                delete filter[name]
            }

            if (filter.hasOwnProperty('products.overtimeGt') === false && name === 'products.overtimeLte' && parseFloat(value) > 0) {
                filter['products.overtimeGt'] = 0
            }

            if (filter.hasOwnProperty('products.remaining_time[from]') === false && name === 'products.remaining_time[to]' && parseFloat(value) > 0) {
                filter['products.remaining_time[from]'] = 0
            }

            delete filter['beforeId']
            delete filter['afterId']

            this.props.onChangeFilter(filter)
        })
    }

    _handleChangeDate = key => newDate => {
        const filter = Object.assign({}, this.state.filter)
        filter.created[key] = changeDateFormat(new Date(newDate))

        if (newDate === '') delete filter.created[key]

        this.props.onChangeFilter(filter)
    }

    _handleChangeDateEnd = key => newDate => {
        const filter = Object.assign({}, this.state.filter)
        let date = moment(newDate)
        date = date.endOf('day')
        filter.created[key] = changeDateFormat(new Date(date))

        if (newDate === '') delete filter.created[key]

        this.props.onChangeFilter(filter)
    }

    _handleChangeDateLabel = key => newDate => {
        const filter = Object.assign({}, this.state.filter)
        filter.generated[key] = changeDateFormat(new Date(newDate))

        if (newDate === '') delete filter.generated[key]

        this.props.onChangeFilter(filter)
    }

    _handleChangeDateEndLabel = key => newDate => {
        const filter = Object.assign({}, this.state.filter)
        let date = moment(newDate)
        date = date.endOf('day')
        filter.generated[key] = changeDateFormat(new Date(date))

        if (newDate === '') delete filter.generated[key]

        this.props.onChangeFilter(filter)
    }

    _handCheckType = () => {
        this.setState({
            product_types_mode: !this.state.product_types_mode,
        }, () => {
            const {filter} = this.state

            this.setState({
                filter: {
                    ...filter,
                    product_types_mode: this.state.product_types_mode ? 'all' : 'in',
                },
            }, () => {
                this.props.onChangeFilter(this.state.filter)
            })
        })
    }

    _checkEndDate = name => current => {
        const {filter} = this.props
        const $gte = filter.created[name]

        if ($gte !== '' && $gte !== null && $gte !== undefined) {
            const yesterday = new Date($gte.getTime() - 24 * 60 * 60 * 1000)
            return current.isAfter(yesterday)
        } else {
            return true
        }
    }

    _setTooltipReset = () => {
        const {tooltipReset} = this.state

        this.setState({
            tooltipReset: !tooltipReset,
        })
    }

    _handleResetFilters = () => {
        this.setState({
            filter: {
                ...INIT_FILTERS, 
                created: {from: '', to: ''}, 
                generated: {from: '', to: ''},
                barcodeNumber: {
                    '$gte': '',
                    '$lte' : ''
                }
            },
            type_overtime: '',
            product_types_mode: false,
            mode: '',
            ListTags: [],
            BrandNames: [],
            Types: []
        }, () => {
            this.props.onChangeFilter({
                ...INIT_FILTERS, 
                created: {from: '', to: ''}, 
                generated: {from: '', to: ''},
                barcodeNumber: {
                    '$gte': '',
                    '$lte' : ''
                }
            })
        })
    }

    handleSearch = (value) => {
        const { filter: _filter } = this.state
        const {storename:store} = {..._filter}
        if (value.includes(',') || value.includes(' ')) {
            const newValue = [...new Set(value.split(',').map(i => i.trim()).filter(i => !!i && i))]
            this.setState({ SearchStoreValue: '' })
            this.setState({
                filter: {
                    ..._filter,
                    storename: [...store, ...newValue],
                },
            },()=>{
                const { filter } = this.state
                this.props.onChangeFilter(filter, 1500)
            })
        } else {
            this.setState({ SearchStoreValue: value })
        }
    }

    onChangeSelect = (field, value) => {
        if (field === 'ListTags') {
            const newValue = [...new Set(value.map(i => {
                const valueInListTags = listTags.find(item => i === item.value || i === item.name)
                return Object.keys(valueInListTags || {}).length > 0 ? valueInListTags.value : i
            }))]
            return this.setState({
                [field]: newValue
            })
        }
        this.setState({
            [field]: value
        })
    }

    onBlurChangeSelect  = (field) => {
        const {onChangeFilter, filter} = this.props
        const {ListTags, BrandNames, Types} = this.state
        if (typeof onChangeFilter === 'function') {
            if(field === "ListTags"){
                onChangeFilter({...filter, list_tags : ListTags})
            }
            if(field === "BrandNames"){
                onChangeFilter({...filter, brand_name : BrandNames})
            }
            if(field === "Types"){
                onChangeFilter({...filter, 'products.type' : Types})
            }
        }
    }

    onDeselectChangeSelect = (field, value) => {
        const {onChangeFilter, filter} = this.props
        const {ListTags = [], BrandNames = [], Types = []} = this.state

        if (typeof onChangeFilter === 'function') {
            if(field === "ListTags"){
                onChangeFilter({...filter, list_tags : ListTags.filter(v => v !== value)})
            }
            if(field === "BrandNames"){
                onChangeFilter({...filter, brand_name : BrandNames.filter(v => v !== value)})
            }
            if(field === "Types"){
                onChangeFilter({...filter, 'products.type' : Types.filter(v => v !== value)})
            }
        }
    }

    _handleFilterPendingRegenerateLabel = () => {
        const { paramsPendingRegenerateLabel = {} } = this.props
        const lastYear = moment().subtract(1, 'year').format('DD/MM/YYYY')

        const baseDefaults = {
            ...INIT_FILTERS,
            created: { from: '', to: '' },
            generated: { from: '', to: '' },
            barcodeNumber: { '$gte': '', '$lte': '' },
        }

        const newFilter = {
            ...paramsPendingRegenerateLabel,
            limit: 500,
            created: { from: lastYear },
        }

        const mergedFilter = { ...baseDefaults, ...newFilter }

        this.setState(
            {
                filter: mergedFilter,
                type_overtime: '',
                product_types_mode: false,
                mode: '',
                ListTags: [],
                BrandNames: [],
                Types: [],
            },
            () => this.props.onChangeFilter(mergedFilter)
        )
    }

    render() {
        const { countPendingRegenerateLabel, onFilterPendingRegenerateLabel } = this.props
        const {filters, type_overtime, error, product_types_mode, filter, mode, delayDays, tooltipReset, SearchStoreValue, listShippingCarrier, allShippingCarrier, ListTags, BrandNames, Types} = this.state
        const { Option } = Select

        return (
            <div className="ListItemFilter border-bottom-1 mt-2">
                <Row form>
                    <Col md={3}>
                        <FilterSelect
                            name="products.size"
                            field="Size"
                            lists={filters.size}
                            value={filter['products.size']}
                            onChange={this._handleChangeSelect}
                        />
                    </Col>
                    <Col md={3}>
                        <FilterSelect
                            name="products.color"
                            field="Color"
                            lists={filters.color}
                            value={filter['products.color']}
                            onChange={this._handleChangeSelect}
                        />
                    </Col>
                    <Col md={3}>
                        <FilterSelect
                            name="products.status"
                            field="Print"
                            lists={listPrint}
                            value={filter['products.status']}
                            onChange={this._handleChangeSelect}
                        />
                    </Col>
                    <Col md={3}>
                        {/* <FilterInput
                            type="text"
                            value={filter.search}
                            name="search"
                            label="Search"
                            onChange={this._handleChangeInput}
                        /> */}
                        <FilterInput
                            type="text"
                            value={filter.package_names}
                            name="package_names"
                            label="Search package name"
                            onChange={this._handleChangeInput}
                        />
                    </Col>

                    <Col md={3}>
                        <FilterInput
                            type="number"
                            value={filter['barcodeNumber']['$gte']}
                            name="$gte"
                            label="From"
                            onChange={this._handleChangeBarcodeNumber}
                        />
                    </Col>
                    <Col md={3}>
                        <FilterInput
                            type="number"
                            value={filter['barcodeNumber']['$lte']}
                            name="$lte"
                            label="To"
                            onChange={this._handleChangeBarcodeNumber}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="MultiSelect">
                            <Label>Type</Label>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Please select"
                                value={Types || []}
                                onChange={value => this.onChangeSelect('Types', value)}
                                onBlur={() => this.onBlurChangeSelect('Types')}
                                onDeselect={(value) => this.onDeselectChangeSelect('Types', value)}
                                className="selectScroll"
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            >
                                {
                                    filters.type.map((item, i) => {
                                        if(!!item){
                                            return <Option key={i} value={item}>{item}</Option>
                                        }
                                    })
                                }
                            </Select>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="pt-4 checkType">
                            <div className="mt-1">
                                <FilterCheckBox
                                    label="Filter Type duy nhất"
                                    value={product_types_mode}
                                    onChange={this._handCheckType}
                                />
                            </div>
                        </div>
                    </Col>

                    <FilterDateTime
                        column={2}
                        placeholder="Chọn thời gian bắt đầu"
                        label="Created from"
                        onChange={this._handleChangeDate('from')}
                        value={filter['created']['from']}
                    />
                    <FilterDateTime
                        column={2}
                        placeholder="Chọn thời gian kết thúc"
                        label="Created to"
                        onChange={this._handleChangeDate('to')}
                        value={filter['created']['to']}
                    />
                    <FilterDateTime
                        column={2}
                        placeholder="Chọn thời gian bắt đầu"
                        label="Gen label from"
                        onChange={this._handleChangeDateLabel('from')}
                        value={filter['generated']['from']}
                    />
                    <FilterDateTime
                        column={2}
                        placeholder="Chọn thời gian kết thúc"
                        label="Gen label to"
                        onChange={this._handleChangeDateLabel('to')}
                        value={filter['generated']['to']}
                    />
                    <Col md={2}>
                        <CustomMultiSelect
                            name="production_status"
                            label={'Production Status'}
                            placeholder={'Chọn trạng thái'}
                            selected={filter.production_status}
                            listFilters={listStatus}
                            onChangeFilters={this._handleChangeSelect}
                        />
                    </Col>
                    <Col md={2}>
                        <div className='CustomMultiSelect form-group'>
                            <label>Shipping carrier</label>
                            <Select
                                className='w-100 shippingCarrier'
                                mode={'multiple'}
                                placeholder={'Chọn shipping carrier'}
                                allowClear
                                value={filter['shipping_carrier']}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                onSearch={(value) => {
                                    if (value) {
                                        const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase())) || []
                                        this.setState({ listShippingCarrier: newList || []})
                                    } else {
                                        this.setState({listShippingCarrier: allShippingCarrier.filter(i=>!!i.is_active) || []})
                                    }
                                }}
                                onBlur={() => this.setState({ listShippingCarrier: allShippingCarrier.filter(i => !!i.is_active) || []})}
                                filterOption={(input, option) => {
                                    return option.children.toLowerCase().includes(input.toLowerCase())
                                }}
                                onChange={(value)=>this._handleChangeSelect('shipping_carrier', value)}
                            >
                                {!!listShippingCarrier && listShippingCarrier.length > 0 &&
                                    listShippingCarrier.map((i, index) => (
                                        <Option key={index} style={!i.is_active ? {} : { color: '#333' }} value={i.slug}>{i.name}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                    </Col>

                    {canViewStoreName() &&
                    <Col md={3}>
                        <div className="MultiSelect">
                            <Label>Store Name</Label>
                            <Select
                                mode={'tags'}
                                className='selectScroll storename'
                                style={{ width: '100%' }}
                                name="storename"
                                onChange={(value)=> this._handleChangeInput('storename', value)}
                                value={filter.storename}
                                onSearch={(value) => this.handleSearch(value)}
                                searchValue={SearchStoreValue || ''}
                                virtual={false}
                                open={false}
                                allowClear
                            >
                            </Select>
                        </div>

                    </Col>}
                    <Col md={2}>
                        <CustomMultiSelect
                            name="status"
                            label={'Label status'}
                            placeholder={'Chọn status label'}
                            selected={filter.status}
                            listFilters={listLabel}
                            onChangeFilters={this._handleChangeSelect}
                        />
                    </Col>
                    <Col md={2}>
                        <FilterSelect
                            name="generate_label_config.mode"
                            field="Delay generate label"
                            lists={listGenerate}
                            value={mode}
                            onChange={this._handleChangeDelay}
                        />
                    </Col>
                    <Col md={2}>
                        <FilterSelect
                            name="shipping_plan"
                            field="Shipping plan"
                            lists={shippingPlan}
                            value={filter.shipping_plan}
                            onChange={this._handleChangeSelect}
                        />
                    </Col>
                    {
                        mode === 'days' && <Col md={3}>
                            <div className="d-flex align-items-center">
                                <FilterInput
                                    type="number"
                                    name="to"
                                    label="Số ngày"
                                    value={delayDays.to}
                                    onChange={this._handleChangeInputDelay}
                                />
                                <div className="ml-1">ngày</div>
                            </div>
                        </Col>
                    }

                    <Col md={3}>
                        <div className="MultiSelect">
                            <Label>Brand Name</Label>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Please select"
                                value={BrandNames || []}
                                onChange={value => this.onChangeSelect('BrandNames', value)}
                                onBlur={() => this.onBlurChangeSelect('BrandNames')}
                                onDeselect={(value) => this.onDeselectChangeSelect('BrandNames', value)}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                className="selectScroll"
                            >
                                {
                                    filters.brand_name.map((item, i) => (
                                        <Option key={i} value={item}>{item}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                    </Col>

                    <Col md={4}>
                        <FilterInput
                            type="textarea"
                            value={filter['order_ids']}
                            name="order_ids"
                            label="OrderIds"
                            onChange={this._handleChangeInput}
                        />
                    </Col>
                    <Col md={4}>
                        <FilterInput
                            type="textarea"
                            value={filter['order_names']}
                            name="order_names"
                            label="Order Names"
                            onChange={this._handleChangeInput}
                        />
                    </Col>
                    <Col md={4}>
                        <FilterInput
                            type="textarea"
                            value={filter['product_types']}
                            name="product_types"
                            label="Product Types"
                            onChange={this._handleChangeInput}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={3}>
                                <FilterSelect
                                    lists={listOverTime}
                                    field="Filter orders"
                                    name="products.overtime"
                                    value={type_overtime}
                                    onChange={this._handleChangeOverTime}
                                />
                            </Col>
                            {type_overtime === 'time' && (
                                <Col md={3}>
                                    <div className="row align-items-md-center flex-md-nowrap FilterOverTime">
                                        <FilterInput
                                            type="number"
                                            name="products.overtimeGt"
                                            label="Từ:"
                                            error={error.from}
                                            value={!isNaN(parseFloat(filter['products.overtimeGt'])) && parseFloat(filter['products.overtimeGt'])}
                                            onChange={this._handleChangeInputOvertime}
                                        />
                                        <span className="ml-1"/>
                                        <FilterInput
                                            type="number"
                                            name="products.overtimeLte"
                                            label="Đến:"
                                            error={error.to}
                                            value={!isNaN(parseFloat(filter['products.overtimeLte'])) && parseFloat(filter['products.overtimeLte'])}
                                            onChange={this._handleChangeInputOvertime}
                                        />
                                        <div className="ml-1">ngày</div>
                                    </div>
                                </Col>
                            )}
                            {type_overtime === 'remaining_time' && (
                                <Col md={3}>
                                    <div className="row align-items-md-center flex-md-nowrap FilterOverTime">
                                        <FilterInput
                                            type="number" name="products.remaining_time[from]"
                                            label="Từ:"
                                            error={error.from}
                                            value={!isNaN(parseFloat(filter['products.remaining_time[from]'])) && parseFloat(filter['products.remaining_time[from]'])}
                                            onChange={this._handleChangeInputOvertime}
                                        />
                                        <span className="ml-1"/>
                                        <FilterInput
                                            type="number"
                                            name="products.remaining_time[to]"
                                            label="Đến:"
                                            error={error.to}
                                            value={!isNaN(parseFloat(filter['products.remaining_time[to]'])) && parseFloat(filter['products.remaining_time[to]'])}
                                            onChange={this._handleChangeInputOvertime}
                                        />
                                        <div className="ml-1">ngày</div>
                                    </div>
                                </Col>
                            )}
                            <Col md={1}>
                                <FilterSelect
                                    name="hasNote"
                                    field="Note"
                                    lists={optionNote}
                                    value={filter.hasNote}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>

                            <Col md={2}>
                                <CustomMultiSelect
                                    name="tags"
                                    label={'Request update'}
                                    placeholder={'Chọn status request update'}
                                    selected={this._getRequestUpdateSelected()}
                                    listFilters={REQUEST_UPDATE_ORDER}
                                    onChangeFilters={this._handleChangeSelect}
                                    mutuallyExclusive={[['waiting-update-design', 'exclude-waiting-update-design']]}
                                />
                            </Col>

                            <Col md={2}>
                                <FilterSelect
                                    name="is_fba"
                                    field="Order Type"
                                    lists={optionOrderType}
                                    value={filter.is_fba ? filter.is_fba : (filter.is_tiktok === 'y' ? 'TikTok' : '')}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>

                            <Col md={2}>
                                <FilterSelect
                                    name="shipping_level"
                                    field="Shipping Type"
                                    lists={shippingLevels}
                                    value={filter.shipping_level}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>

                            <Col md={2}>
                                <div className="MultiSelect">
                                    <Label>Tags</Label>
                                    <Select
                                        mode="tags"
                                        style={{ width: '100%' }}
                                        placeholder="Please select"
                                        value={ListTags || []}
                                        onChange={value => this.onChangeSelect('ListTags', value)}
                                        onBlur={() => this.onBlurChangeSelect('ListTags')}
                                        onDeselect={(value) => this.onDeselectChangeSelect('ListTags', value)}
                                        className="selectScroll"
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    >
                                        {
                                            listTags.map((item, idx) => <Option key={`Tags_${item.value}_${idx}`} value={item.value}>{item.name}</Option>)
                                        }
                                    </Select>
                                </div>
                            </Col>

                            <Col md={2}>
                                <FilterSelect
                                    name="mark_qc_error"
                                    field="Lỗi 2D"
                                    lists={optionsError2D}
                                    value={filter.mark_qc_error}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>

                            <Col md={2}>
                                <FilterSelect
                                    name="warning_ship"
                                    field="Cảnh báo ship"
                                    lists={listWarningShip}
                                    value={filter.warning_ship}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>
                            <Col md={2}>
                                <FilterSelect
                                    name="partner"
                                    field="Partner"
                                    lists={listPartner}
                                    value={filter.partner}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>

                            <Col md={1}>
                                <FilterSelect
                                    name="is_hold_ship"
                                    field="Hold ship"
                                    lists={optionsHoldShip}
                                    value={filter.is_hold_ship}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>
                            <Col md={1}>
                                <FilterSelect
                                    name="is_combine_ship"
                                    field="Combine ship"
                                    lists={optionsCombineShip}
                                    value={filter.is_combine_ship}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>
                            <Col md={1}>
                                <FilterSelect
                                    name="photo_requested"
                                    field="Request photo"
                                    lists={optionsRequestPhotoStatus}
                                    value={filter.photo_requested}
                                    onChange={this._handleChangeSelect}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <div id="tooltipReset" className="resetFilters">
                    <i onClick={this._handleResetFilters} className="icon-spinner11"/>
                    <Tooltip
                        isOpen={tooltipReset}
                        target="tooltipReset"
                        toggle={this._setTooltipReset}
                    >
                        Reset filters
                    </Tooltip>
                </div>
                
                {
                    !!countPendingRegenerateLabel &&
                    <h5
                        className='text-danger font-weight-bold mb-1 cursor-pointer d-inline-block'
                        onClick={this._handleFilterPendingRegenerateLabel}
                    >{countPendingRegenerateLabel} đơn hàng có cập nhật địa chỉ
                    </h5>
                }
            </div>
        )
    }
}

export default ListItemsFilter
